<template>
    <div class="card-body">

        <title-header title="Presidente"></title-header>

        <div class="content">

            <div class="flex items-center flex-col justify-center">
                <img
                    src="../../../../../img/AMAURI_SERGIO_MORTAGUA.jpeg"
                    alt="fachada"
                    class="mb-6"
                />
                <h3>Amauri Sérgio Mortágua</h3>
            </div>


            <h3 class="mt-10 font-semibold text-left w-full">A Central do Século XXI</h3>
            <p class="card-text mt-3">
                A UGT-SP, a Central do Século XXI, vivencia este “slogan” no seu dia a dia e de forma proativa. Quando realizamos eventos temáticos, como a
                resistência, reação e, posteriormente, os impactos, reflexos e sequelas da MP 873, estamos, em primeiro lugar, promovendo o encontro e a
                integração entre os filiados, mas também contribuindo para fortalecer a unidade de ação, dentro e fora do âmbito das entidades.
                Isto para dizer que os dirigentes da Central do Século XXI têm a clara percepção de que não basta se limitar à força de um slogan que
                remete à atualidade e a questões futuras.
            </p>
            <p class="card-text">
                Recentemente, a UGT-SP debateu as ameaças da MP 881 e sua autorização dos trabalhos aos domingos e feriados, entre outras maldades.
                Conscientes destes riscos, reunimos especialistas e saímos de Jaú com encaminhamentos que, no Congresso Nacional, contribuíram para
                sensibilizar parlamentares a votarem contra este novo retrocesso à classe trabalhadora. Sim, a retirada do trecho da MP 881 que tratava
                do trabalho aos domingos e feriados contou, entre seus subsídios, com a colaboração da UGT-SP. Presunção? Não. Realidade!
            </p>

            <h3 class="mt-5 font-semibold text-left w-full">Instrumentos de luta</h3>
            <p class="card-text mt-3">
                É preciso entender que, assim como vem ocorrendo com a tramitação, no Congresso Nacional, da Reforma da Previdência, somos uma Central Sindical
                que, permanentemente, discute, delibera e apresenta propostas de ação sobre temas que pautam o sindicalismo. De posse destas diretrizes, atuamos
                com unidade nos locais de trabalho e, com elas, percorremos os gabinetes dos senadores e dos deputados federais. Ou seja, fazemos das nossas
                resoluções instrumentos de luta para preservar os sagrados direitos dos trabalhadores. Obtivemos vitórias junto às MPs 873 e 881 e, também,
                somamos algumas conquistas durante as votações da reforma previdenciária na Câmara. Agora, a atenção se redobra no Senado, neste tema,
                para a defesa dos direitos dos brasileiros.
            </p>
            <p class="card-text">
                Assim, seguiremos com a mesma postura diante de matérias igualmente preocupantes, como as anunciadas propostas de Reforma Sindical.
                Somos protagonistas de discussões que hoje balizam o sindicalismo. Nossos debates sobre o futuro do movimento sindical começam a ser
                preparados. Sem tutelar as entidades filiadas, mas definindo diretrizes conjuntas, continuaremos a nos reunir para unir forças e
                possibilitar as tomadas de decisões certas sobre rumos comuns, sempre cientes e alertas aos sinais dos tempos. Afinal, somos a Central do Século XXI.
            </p>

        </div>
    </div>
</template>

<script>
export default {
    name: "presidente"
};
</script>

<style lang="scss" scoped>
.card-body {
    @apply p-20 pt-0;
    @media (max-width: 668px) {
        @apply p-8;
    }
    .content {
        @apply flex flex-col items-center justify-center;
        img {
            @apply mb-4;
            width: 200px;
        }

        p {
            @apply mb-4 text-base;
        }
    }
}
</style>
